import React, { useState, useEffect } from "react";
import {
  Card,
  InputGroup,
  Form,
  Modal,
  Button,
  Spinner,
} from "react-bootstrap";
import _ from "lodash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faGraduationCap,
  faPaperPlane,
  faPodcast,
  faTimes,
  faUser,
  faSearch,
} from "@fortawesome/free-solid-svg-icons";
import { changeLanguage } from "../../../store/actions/actions";
import { connect } from "react-redux";
import { useHistory, useLocation } from "react-router";
import { sendEmail } from "../../../utils/index";
import { toast } from "react-toastify";
import firebase from "firebase";
import { API_BASE_URL, DRIVE_UPLOAD } from "../../../config/index";
import axios from "axios";
import "react-toastify/dist/ReactToastify.css";
import { useCollection } from "react-firebase-hooks/firestore";
import { languageText as languageTextToast } from "../EventManager/language.json";

function Dashboard(props) {
  const history = useHistory();
  const { hash, pathname } = useLocation();
  const userDetails = firebase.auth().currentUser;
  const { currentLanguage } = props;

  const [showProfile, setShowProfile] = useState(false);
  const [selectedProfile, setSelectedProfile] = useState(null);

  const [showAddSpeakerModal, setShowAddSpeakerModal] = useState(false);
  const [speakerDetails, setSpeakerDetails] = useState({});
  const [isUpdating, setIsUpdating] = useState(false);
  const [saving, setSaving] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");
  const [regex, setRegex] = useState("");

  const [speakersSnapshot, loading, error] = useCollection(
    firebase.firestore().collection("/projects/HbPEhf876hUdOhe22RsK/members")
  );

  let sortedSpeakers = speakersSnapshot?.docs.map((speaker) => ({
    ...speaker.data(),
    id: speaker.id,
  }));

  const getWhetherURLOrLocalFile = (file) => {
    if (!file.name) {
      return file;
    } else {
      return URL.createObjectURL(file);
    }
  };

  const img_src_url = speakerDetails.img_src
    ? getWhetherURLOrLocalFile(speakerDetails.img_src)
    : null;

  const peopleList = [
    {
      name: "Lim Yong kang",
      avatar:
        "https://file.hstatic.net/200000067792/article/1._andrew_lim_5a0b893416ae475891523ac60a5a91f9.png",
      email: "lim@gmail.com",
      username: "lim",
    },
    {
      name: "S Hayat",
      avatar:
        "https://i.pinimg.com/originals/31/54/20/3154204284fb98ef1a893fb02e89dc9c.png",
      email: "shayat@gmail.com",
      username: "shayat",
    },
    {
      name: "Siddhesh Pawar",
      avatar:
        "https://t3.ftcdn.net/jpg/02/95/21/58/360_F_295215888_nNSFXTYYPi1UNvKALPD90T5oDS631ife.jpg",
      email: "siddhesh@gmail.com",
      username: "siddhesh",
    },
    {
      name: "Richard Moon",
      avatar:
        "https://img2.pngio.com/man-professional-haircut-picturepng-professional-men-png-321_290.jpg",
      email: "richard@gmail.com",
      username: "richard",
    },
    {
      name: "Sathvik Saya",
      avatar:
        "https://t4.ftcdn.net/jpg/01/56/19/15/360_F_156191504_F8KusEJnAdRbyztflKKtQnnU43GIyWv4.jpg",
      email: "sathvik@gmail.com",
      username: "sathvik",
    },
  ];

  const saveFileToStateHandler = (e) => {
    setSpeakerDetails((prevSpeakersdata) => {
      return { ...prevSpeakersdata, [e.target.name]: e.target.files[0] };
    });
  };

  const uploadFile = async (file) => {
    if (file.name) {
      const fileData = new FormData();

      fileData.append("file", file, `${file.lastModified}-${file.name}`);
      fileData.append(
        "user_id",
        userDetails?.uid ?? "1gHTSDwzWRPW7KAUeTcscDFxs7z2"
      );

      const config = {
        headers: {
          "content-type": "multipart/form-data",
        },
      };
      if (file) {
        try {
          let res = await axios.post(
            `${API_BASE_URL}${DRIVE_UPLOAD}`,
            fileData,
            config
          );
          return res.data.data["file_url"];
        } catch (error) {
          console.error(error, "error in writing file to db");
        }
      } else return "";
    } else {
      return file;
    }
  };

  const addSpeaker = async (e, speakersData) => {
    e.preventDefault();
    // if (speakersData.email_address.trim().length) {
    const emailAlreadyExists = speakersData.email_address?.trim().length
      ? (
          await firebase
            .firestore()
            .collection("/projects/HbPEhf876hUdOhe22RsK/members")
            .where(
              "email_address",
              "==",
              speakersData.email_address.toLowerCase()
            )
            .get()
        ).docs.length
      : false;
    if (!emailAlreadyExists) {
      const order_index = speakersSnapshot.docs.length + 1;
      const imgSrcURL = speakersData.img_src
        ? await uploadFile(speakersData.img_src)
        : null;
      try {
        setSaving(true);
        await firebase
          .firestore()
          .collection("/projects/HbPEhf876hUdOhe22RsK/members")
          .doc()
          .set({
            first_name: speakersData.first_name ?? "",
            last_name: speakersData.last_name ?? "",
            designation: speakersData.designation ?? "",
            organisation: speakersData.organisation ?? "",
            img_src: imgSrcURL ?? "",
            order_index: +order_index,
            id: +order_index,
            email_address: speakersData.email_address ?? "",
            user_role: 2,
            timestamp_of_assigning: new Date().valueOf(),
          });
        await sendEmail({
          to: speakersData.email_address,
          subject: `You are invited to be a member at ${props?.project?.name}`,
          content: `<!DOCTYPE HTML PUBLIC "-//W3C//DTD XHTML 1.0 Transitional //EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd"><html xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office"><head> <!--[if gte mso 9]> <xml> <o:OfficeDocumentSettings> <o:AllowPNG/> <o:PixelsPerInch>96</o:PixelsPerInch> </o:OfficeDocumentSettings> </xml> <![endif]--><meta http-equiv="Content-Type" content="text/html; charset=UTF-8"><meta name="viewport" content="width=device-width, initial-scale=1.0"><meta name="x-apple-disable-message-reformatting"> <!--[if !mso]><!--><meta http-equiv="X-UA-Compatible" content="IE=edge"> <!--<![endif]--><title></title><style type="text/css">a{color:#161a39;text-decoration:underline}@media only screen and (min-width: 620px){.u-row{width:600px !important}.u-row .u-col{vertical-align:top}.u-row .u-col-100{width:600px !important}}@media (max-width: 620px){.u-row-container{max-width:100% !important;padding-left:0px !important;padding-right:0px !important}.u-row .u-col{min-width:320px !important;max-width:100% !important;display:block !important}.u-row{width:calc(100% - 40px) !important}.u-col{width:100% !important}.u-col>div{margin:0 auto}}body{margin:0;padding:0}table,tr,td{vertical-align:top;border-collapse:collapse}p{margin:0}.ie-container table, .mso-container table{table-layout:fixed}*{line-height:inherit}a[x-apple-data-detectors='true']{color:inherit !important;text-decoration:none !important}</style><!--[if !mso]><!--><link href="https://fonts.googleapis.com/css?family=Lato:400,700&display=swap" rel="stylesheet" type="text/css"> <!--<![endif]--></head><body class="clean-body" style="margin: 0;padding: 0;-webkit-text-size-adjust: 100%;background-color: #f9f9f9"> <!--[if IE]><div class="ie-container"><![endif]--> <!--[if mso]><div class="mso-container"><![endif]--><table style="border-collapse: collapse;table-layout: fixed;border-spacing: 0;mso-table-lspace: 0pt;mso-table-rspace: 0pt;vertical-align: top;min-width: 320px;Margin: 0 auto;background-color: #f9f9f9;width:100%" cellpadding="0" cellspacing="0"><tbody><tr style="vertical-align: top"><td style="word-break: break-word;border-collapse: collapse !important;vertical-align: top"> <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td align="center" style="background-color: #f9f9f9;"><![endif]--><div class="u-row-container" style="padding: 0px;background-color: #f9f9f9"><div class="u-row" style="Margin: 0 auto;min-width: 320px;max-width: 600px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #f9f9f9;"><div style="border-collapse: collapse;display: table;width: 100%;background-color: transparent;"> <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding: 0px;background-color: #f9f9f9;" align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:600px;"><tr style="background-color: #f9f9f9;"><![endif]--><!--[if (mso)|(IE)]><td align="center" width="600" style="width: 600px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;" valign="top"><![endif]--><div class="u-col u-col-100" style="max-width: 320px;min-width: 600px;display: table-cell;vertical-align: top;"><div style="width: 100% !important;"> <!--[if (!mso)&(!IE)]><!--><div style="padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;"> <!--<![endif]--><table style="font-family:'Lato',sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0"><tbody><tr><td style="overflow-wrap:break-word;word-break:break-word;padding:15px;font-family:'Lato',sans-serif;" align="left"><table height="0px" align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="border-collapse: collapse;table-layout: fixed;border-spacing: 0;mso-table-lspace: 0pt;mso-table-rspace: 0pt;vertical-align: top;border-top: 1px solid #f9f9f9;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%"><tbody><tr style="vertical-align: top"><td style="word-break: break-word;border-collapse: collapse !important;vertical-align: top;font-size: 0px;line-height: 0px;mso-line-height-rule: exactly;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%"> <span>&#160;</span></td></tr></tbody></table></td></tr></tbody></table><!--[if (!mso)&(!IE)]><!--></div> <!--<![endif]--></div></div> <!--[if (mso)|(IE)]></td><![endif]--> <!--[if (mso)|(IE)]></tr></table></td></tr></table><![endif]--></div></div></div><div class="u-row-container" style="padding: 0px;background-color: transparent"><div class="u-row" style="Margin: 0 auto;min-width: 320px;max-width: 600px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #ffffff;"><div style="border-collapse: collapse;display: table;width: 100%;background-color: transparent;"> <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding: 0px;background-color: transparent;" align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:600px;"><tr style="background-color: #ffffff;"><![endif]--><!--[if (mso)|(IE)]><td align="center" width="600" style="width: 600px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;" valign="top"><![endif]--><div class="u-col u-col-100" style="max-width: 320px;min-width: 600px;display: table-cell;vertical-align: top;"><div style="width: 100% !important;"> <!--[if (!mso)&(!IE)]><!--><div style="padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;"> <!--<![endif]--><table style="font-family:'Lato',sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0"><tbody><tr><td style="overflow-wrap:break-word;word-break:break-word;padding:25px 0px;font-family:'Lato',sans-serif;" align="left"><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding-right: 20px; padding-left: 30px;" align="left"><img align="left" border="0" src=${props?.project.image} alt="Image" title="Image" style="outline: none;text-decoration: none;-ms-interpolation-mode: bicubic;clear: both; display: inline-block !important;border: none;height: auto;float: none;width: 53%;max-width: 307.4px; border-radius: 4px;" width="307.4" /></td></tr></table></td></tr></tbody></table><!--[if (!mso)&(!IE)]><!--></div> <!--<![endif]--></div></div> <!--[if (mso)|(IE)]></td><![endif]--> <!--[if (mso)|(IE)]></tr></table></td></tr></table><![endif]--></div></div></div><div class="u-row-container" style="padding: 0px;background-color: transparent"><div class="u-row" style="Margin: 0 auto;min-width: 320px;max-width: 600px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #ffffff;"><div style="border-collapse: collapse;display: table;width: 100%;background-color: transparent;"> <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding: 0px;background-color: transparent;" align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:600px;"><tr style="background-color: #ffffff;"><![endif]--><!--[if (mso)|(IE)]><td align="center" width="600" style="width: 600px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;" valign="top"><![endif]--><div class="u-col u-col-100" style="max-width: 320px;min-width: 600px;display: table-cell;vertical-align: top;"><div style="width: 100% !important;"> <!--[if (!mso)&(!IE)]><!--><div style="padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;"> <!--<![endif]--><table style="font-family:'Lato',sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0"><tbody><tr><td style="overflow-wrap:break-word;word-break:break-word;padding:10px 40px 30px;font-family:'Lato',sans-serif;" align="left"><div style="color: #000000; line-height: 140%; text-align: left; word-wrap: break-word;"><p style="font-size: 14px; line-height: 140%;"><span style="font-size: 18px; line-height: 25.2px; color: #34495e; font-family: helvetica, sans-serif;">Hi,</span></p><p style="font-size: 14px; line-height: 140%;">&nbsp;</p><p style="font-size: 14px; line-height: 140%;"><span style="font-family: helvetica, sans-serif; font-size: 18px; line-height: 25.2px; color: #34495e;">You are invited to be a member at ${props?.project.name}. </span></p><p style="font-size: 14px; line-height: 140%;"> <br /> <span style="font-family: helvetica, sans-serif; font-size: 18px; line-height: 25.2px; color: #34495e;">Please register as a member using the <strong style="background-color: #FFF000;">same email address</strong> where you are recieving this email invite. </span></p></div></td></tr></tbody></table><table style="font-family:'Lato',sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0"><tbody><tr><td style="overflow-wrap:break-word;word-break:break-word;padding:0px 40px;font-family:'Lato',sans-serif;" align="left"><div align="left"> <!--[if mso]><table width="100%" cellpadding="0" cellspacing="0" border="0" style="border-spacing: 0; border-collapse: collapse; mso-table-lspace:0pt; mso-table-rspace:0pt;font-family:'Lato',sans-serif;"><tr><td style="font-family:'Lato',sans-serif;" align="left"><v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" href="" style="height:51px; v-text-anchor:middle; width:253px;" arcsize="2%" stroke="f" fillcolor="#3598db"><w:anchorlock/><center style="color:#FFFFFF;font-family:'Lato',sans-serif;"><![endif]--> <a href="https://events.igesia.co/event/template/register/${speakersData.email_address}" target="_blank" style="box-sizing: border-box;display: inline-block;font-family:'Lato',sans-serif;text-decoration: none;-webkit-text-size-adjust: none;text-align: center;color: #FFFFFF; background-color: #3598db; border-radius: 4px; -webkit-border-radius: 4px; -moz-border-radius: 4px; width:auto; max-width:100%; overflow-wrap: break-word; word-break: break-word; word-wrap:break-word; mso-border-alt: none;"> <span style="display:block;padding:15px 40px;line-height:120%;"><strong><span style="font-size: 18px; line-height: 21.599999999999998px;">Register now</span></strong></span> </a> <!--[if mso]></center></v:roundrect></td></tr></table><![endif]--><p style="font-size: 14px; line-height: 140%; margin-top:30px"> <br /> Please write to <a href="mailto:support@igesia.co"> support@igesia.co</a> for assistance. <br /></p></div></td></tr></tbody></table><table style="font-family:'Lato',sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0"><tbody><tr><td style="overflow-wrap:break-word;word-break:break-word;padding:40px 40px 30px;font-family:'Lato',sans-serif;" align="left"><div style="color: #000000; line-height: 140%; text-align: left; word-wrap: break-word;"><p style="font-size: 14px; line-height: 140%;"><span style="color: #888888; font-size: 14px; line-height: 19.599999999999998px; font-family: helvetica, sans-serif;"><em><span style="line-height: 19.599999999999998px; font-size: 14px;">Event powered by <a href="http://events.igesia.co/" target="_blank" rel="noopener">igesia</a></span></em></span></p><p style="font-size: 14px; line-height: 140%;"><span style="font-family: helvetica, sans-serif; font-size: 14px; line-height: 19.599999999999998px;">&copy; [igesia] 2021. All rights reserved.</span><br /><span style="color: #888888; font-size: 14px; line-height: 19.599999999999998px; font-family: helvetica, sans-serif;"><em><span style="font-size: 16px; line-height: 22.4px;">&nbsp;</span></em></span></p></div></td></tr></tbody></table><!--[if (!mso)&(!IE)]><!--></div> <!--<![endif]--></div></div> <!--[if (mso)|(IE)]></td><![endif]--> <!--[if (mso)|(IE)]></tr></table></td></tr></table><![endif]--></div></div></div><div class="u-row-container" style="padding: 0px;background-color: transparent"><div class="u-row" style="Margin: 0 auto;min-width: 320px;max-width: 600px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #f9f9f9;"><div style="border-collapse: collapse;display: table;width: 100%;background-color: transparent;"> <!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding: 0px;background-color: transparent;" align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:600px;"><tr style="background-color: #f9f9f9;"><![endif]--><!--[if (mso)|(IE)]><td align="center" width="600" style="width: 600px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;" valign="top"><![endif]--><div class="u-col u-col-100" style="max-width: 320px;min-width: 600px;display: table-cell;vertical-align: top;"><div style="width: 100% !important;"> <!--[if (!mso)&(!IE)]><!--><div style="padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;"> <!--<![endif]--><table style="font-family:'Lato',sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0"><tbody><tr><td style="overflow-wrap:break-word;word-break:break-word;padding:0px 40px 30px 20px;font-family:'Lato',sans-serif;" align="left"><div style="color: #000000; line-height: 140%; text-align: left; word-wrap: break-word;"></div></td></tr></tbody></table><!--[if (!mso)&(!IE)]><!--></div> <!--<![endif]--></div></div> <!--[if (mso)|(IE)]></td><![endif]--> <!--[if (mso)|(IE)]></tr></table></td></tr></table><![endif]--></div></div></div><!--[if (mso)|(IE)]></td></tr></table><![endif]--></td></tr></tbody></table> <!--[if mso]></div><![endif]--> <!--[if IE]></div><![endif]--></body></html>`,
          from: '"igesia" <noreply@igesia.co>',
        });
        toast.success("Speaker added", {
          position: toast.POSITION.TOP_CENTER,
          hideProgressBar: true,
          autoClose: 3000,
        });
      } catch (e) {
        console.error(e, "unable to write to db");
      } finally {
        setSaving(false);
        setSpeakerDetails({});
        setShowAddSpeakerModal(false);
      }
    } else {
      toast.error(languageTextToast[`${currentLanguage}`].error, {
        position: toast.POSITION.TOP_CENTER,
        hideProgressBar: true,
        autoClose: 3000,
      });
      setSaving(false);
    }
    // } else {
    //   //set error email is empty
    //   toast.error(languageTextToast[`${currentLanguage}`].emailEmptyInBooth, {
    //     position: toast.POSITION.TOP_CENTER,
    //     hideProgressBar: true,
    //     autoClose: 3000,
    //   });
    // }
  };

  const saveTextDataToStateHandler = (e) => {
    setSpeakerDetails((prevSpeakersdata) => {
      return { ...prevSpeakersdata, [e.target.name]: e.target.value };
    });
  };

  return (
    <>
      <div className=" bg-graphite ">
        <div className="">
          <h2 className="font-weight-bold text-white">Members</h2>
          <Button onClick={() => setShowAddSpeakerModal(true)}>
            Add Members
          </Button>
          <div className="mt-3 mt-md-4 ">
            <div className="">
              {/* Upcoming Live Sessions */}
              <InputGroup className="my-2 outerPill">
                <div className="d-flex align-items-center rounded-lg flex-grow-1  bg-dark">
                  <div className="py-2 pr-2 pl-3">
                    <FontAwesomeIcon
                      icon={faSearch}
                      size="sm"
                      color="#aeaeae"
                    />
                  </div>
                  <div className="flex-grow-1">
                    <Form.Control
                      type="text"
                      id="participantsSearch"
                      className="border-0 px-0 bg-dark text-white rounded"
                      onChange={(e) => {
                        setSearchTerm(e.target.value);
                        const reg = _.escapeRegExp(searchTerm);
                        // console.log(reg,"Reg")
                        const regex = new RegExp(reg, "gi");
                        setRegex(regex);
                      }}
                      placeholder={"Search"}
                      value={searchTerm}
                      style={{ margin: 0 }}
                    />
                  </div>
                  {searchTerm.length > 0 && (
                    <div
                      className="py-2 pl-2 pr-3"
                      onClick={() => setSearchTerm("")}
                    >
                      <FontAwesomeIcon icon={faTimes} color="#aeaeae" />
                    </div>
                  )}
                </div>
              </InputGroup>
              <div
                className="mb-3 mb-md-5"
                //id="#outcomes"
                //ref={outcomesRef}
              >
                {searchTerm && searchTerm.length > 0 ? (
                  <>
                    {sortedSpeakers
                      ?.filter((item) => {
                        return item.first_name?.match(regex);
                      })
                      .map((item) => {
                        return (
                          <Card
                            onClick={() => {
                              setSelectedProfile(item);
                              setShowProfile(true);
                            }}
                            className="bg-dark text-white shadow-sm mb-2"
                          >
                            <Card.Body>
                              <div className="d-flex">
                                <div
                                  className="img-fluid rounded-circle shadow-sm border"
                                  style={{
                                    height: 50,
                                    width: 50,
                                    backgroundImage: `url(${item.avatar})`,
                                    backgroundPosition: "center",
                                    backgroundSize: "cover",
                                    backgroundRepeat: "no-repeat",
                                  }}
                                  title={item.name}
                                />
                                <div className="ml-2">
                                  <p className="mb-0">{item.name}</p>
                                  <span className="small">{item.email}</span>
                                </div>
                              </div>
                            </Card.Body>
                          </Card>
                        );
                      })}
                  </>
                ) : (
                  <>
                    {sortedSpeakers?.map((item) => {
                      return (
                        <Card
                          onClick={() => {
                            setSelectedProfile(item);
                            setShowProfile(true);
                          }}
                          className="bg-dark text-white shadow-sm mb-2"
                        >
                          <Card.Body>
                            <div className="d-flex">
                              <div
                                className="img-fluid rounded-circle shadow-sm border"
                                style={{
                                  height: 50,
                                  width: 50,
                                  backgroundImage: `url(${item.img_src})`,
                                  backgroundPosition: "center",
                                  backgroundSize: "cover",
                                  backgroundRepeat: "no-repeat",
                                }}
                                title={item.name}
                              />
                              <div className="ml-2">
                                <p className="mb-0">{`${item.first_name} ${item.last_name}`}</p>
                                <span className="small">
                                  {item.email_address}
                                </span>
                              </div>
                            </div>
                          </Card.Body>
                        </Card>
                      );
                    })}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal
        centered={true}
        show={showProfile}
        onHide={() => setShowProfile(false)}
        animation={true}
      >
        <Modal.Body className="bg-graphite text-white">
          <div
            title="Close"
            className="pointer d-flex justify-content-end mb-0"
            onClick={() => setShowProfile(false)}
          >
            <FontAwesomeIcon className="text-white" icon={faTimes} />
          </div>
          <div className="d-flex flex-column align-items-center text-center">
            <div
              className="img-fluid rounded-circle shadow-sm"
              style={{
                height: 120,
                width: 120,
                backgroundImage: `url(${selectedProfile?.img_src})`,
                backgroundPosition: "center",
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
              }}
              title={selectedProfile?.first_name}
            />
            <p className="font-weight-bold lead">
              {`${selectedProfile?.first_name} ${selectedProfile?.last_name}`}
            </p>
            <div className="w-100 d-flex align-items-center justify-content-around">
              <p className="border-right border-dark w-100 text-lowercase">{`@${
                selectedProfile?.first_name?.split(" ")[0]
              }`}</p>
              <p className="w-100">{`${selectedProfile?.email_address}`}</p>
            </div>
            <p>{`USA`}</p>
            <div className="row w-100">
              <div className="col-sm">
                <FontAwesomeIcon icon={faGraduationCap} />
                <p>{`14`}</p>
              </div>
              <div className="col-sm">
                <FontAwesomeIcon icon={faUser} />
                <p>{`1251`}</p>
              </div>
              <div className="col-sm">
                <FontAwesomeIcon icon={faPodcast} />
                <p>{`43`}</p>
              </div>
            </div>
            <hr />
            <div>
              <p className="lead font-weight-bold">Specifications</p>
              <p>{`Innovation • Artificial Intelligence • Services Operations Management • Technology Strategy`}</p>
            </div>
            <hr />
            <div>
              <p className="lead font-weight-bold">Qualifications</p>
              <p>{`PhD • MS • Btech`}</p>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={showAddSpeakerModal}
        onHide={() => {
          setSpeakerDetails({});
          setIsUpdating(false);
          setShowAddSpeakerModal(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Add speaker information
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <div className="row">
              <Form.Group className="col-md-12">
                <Form.Label>Profile picture</Form.Label>
                {speakerDetails.img_src ? (
                  <div className="mb-2">
                    <img
                      alt=""
                      src={img_src_url}
                      className="img-fluid rounded-circle"
                      style={{ width: "100px", height: "100px" }}
                    ></img>
                  </div>
                ) : null}
                <Form.Control
                  type="file"
                  accept="image/*"
                  name="img_src"
                  onChange={(e) => saveFileToStateHandler(e)}
                  className="border p-1 rounded"
                  style={{ cursor: "pointer" }}
                />
              </Form.Group>
              <Form.Group className="col-md-6">
                <Form.Label>Name</Form.Label>
                <Form.Control
                  type="text"
                  value={speakerDetails.first_name}
                  placeholder="First Name"
                  name="first_name"
                  onChange={(e) => saveTextDataToStateHandler(e)}
                />
              </Form.Group>
              <Form.Group className="col-md-6">
                <Form.Label>Last name</Form.Label>
                <Form.Control
                  type="text"
                  value={speakerDetails.last_name}
                  placeholder="Last name"
                  name="last_name"
                  onChange={(e) => saveTextDataToStateHandler(e)}
                />
              </Form.Group>
              <Form.Group className="col-md-12">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Email"
                  value={speakerDetails.email_address}
                  name="email_address"
                  onChange={(e) => saveTextDataToStateHandler(e)}
                />
              </Form.Group>
              <Form.Group className="col-md-6">
                <Form.Label>Organisation</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Organisation"
                  value={speakerDetails.organisation}
                  name="organisation"
                  onChange={(e) => saveTextDataToStateHandler(e)}
                />
              </Form.Group>
              <Form.Group className="col-md-6">
                <Form.Label>Designation</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Designation"
                  value={speakerDetails.designation}
                  name="designation"
                  onChange={(e) => saveTextDataToStateHandler(e)}
                />
              </Form.Group>
              {/* <Form.Group className="col-md-6">
                <Form.Label>Twitter</Form.Label>
                <Form.Control type="text" placeholder="Twitter" />
              </Form.Group>
              <Form.Group className="col-md-6 mx-auto">
                <Form.Label>LinkedIn</Form.Label>
                <Form.Control type="text" placeholder="LinkedIn" />
              </Form.Group> */}
            </div>
            {!isUpdating ? (
              <Button
                variant="primary"
                className="w-100"
                onClick={(e) => addSpeaker(e, speakerDetails)}
                disabled={saving}
              >
                {saving ? <Spinner animation="border" size="sm" /> : "Submit"}
              </Button>
            ) : (
              <Button
                variant="primary"
                className="w-100"
                //onClick={(e) => updateSpeaker(e, speakerDetails)}
                disabled={saving}
              >
                {saving ? <Spinner animation="border" size="sm" /> : "Update"}
              </Button>
            )}
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default connect(
  (state) => ({
    currentLanguage: state.currentLanguage,
    project: state.project,
  }),
  { changeLanguage }
)(Dashboard);
